import actions from './actions';
import mutations from './mutations';
import * as getters from './getters';

const state = () => ({
  similarCompanies: [],
  similarCompaniesPage: 1,
  similarCompaniesError: null,
  similarCompaniesLoading: false,
  isViewMoreVisible: true
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
